<template>
  <section class="reservation-hero">
    <div class="res-card">
      <div class="res-avatar-ring">
        <img src="@/assets/images/favicon.png" alt="أ/طارق عبدالغني عبدالباري" />
      </div>
      <div class="res-name">أ/ طارق عبدالغني عبدالباري</div>
      <div class="res-subtitle">مدرس الرياضيات للمرحلة الإعدادية والثانوية</div>
      <div class="res-announcement">
        <span class="res-badge">🎉 إعلان</span>
        <p>تم بدء الحجز</p>
      </div>
      <router-link to="/reservation" class="btn-primary">📋 احجز مكانك الآن</router-link>
      <router-link to="/search" class="btn-secondary">🔍 ابحث عن حجزك الآن</router-link>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800;900&display=swap');

.reservation-hero {
  min-height: calc(100vh - 140px);
  display: flex; align-items: center; justify-content: center;
  padding: 2rem 1rem;
  background: linear-gradient(135deg,#EEF2FF 0%,#F5F7FB 55%,#E0F2FE 100%);
  font-family: 'Cairo', sans-serif; direction: rtl;
}
.res-card {
  background: rgba(255,255,255,.93); backdrop-filter: blur(24px);
  border-radius: 32px; padding: 3rem 2.5rem;
  box-shadow: 0 30px 80px rgba(0,0,0,.12);
  display: flex; flex-direction: column; align-items: center;
  gap: 1.25rem; max-width: 460px; width: 100%; text-align: center;
}
.res-avatar-ring {
  width: 100px; height: 100px; border-radius: 50%;
  padding: 4px; background: linear-gradient(135deg,#5B5FEF,#7C4DFF);
  box-shadow: 0 12px 32px rgba(91,95,239,.3);
  display: flex; align-items: center; justify-content: center;
  animation: floatY 3s ease-in-out infinite;
}
.res-avatar-ring img { width:100%; height:100%; border-radius:50%; border:3px solid #fff; }
.res-name {
  font-size:1.75rem; font-weight:800;
  background:linear-gradient(135deg,#5B5FEF,#7C4DFF);
  -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
}
.res-subtitle { font-size:.92rem; color:#6B7280; }
.res-announcement {
  background:rgba(91,95,239,.06); border:1.5px solid rgba(91,95,239,.14);
  border-radius:16px; padding:1rem 1.5rem; width:100%;
}
.res-badge {
  background:linear-gradient(135deg,#5B5FEF,#7C4DFF); color:#fff;
  padding:.2rem .75rem; border-radius:99px; font-size:.78rem; font-weight:700;
  display:inline-block; margin-bottom:.5rem;
}
.res-announcement p { margin:0; color:#1A1A1A; font-weight:600; font-size:1rem; }
.btn-primary {
  display: inline-flex; align-items: center; justify-content: center; gap: .6rem;
  padding: .9rem 2rem; border-radius: 99px; font-weight: 700; font-size: 1rem;
  text-decoration: none; font-family: 'Cairo', sans-serif; width: 100%;
  background: linear-gradient(135deg,#5B5FEF,#7C4DFF); color: #fff;
  box-shadow: 0 12px 32px rgba(91,95,239,.3);
  transition: all .3s cubic-bezier(.4,0,.2,1);
}
.btn-primary:hover { transform: translateY(-3px); box-shadow: 0 20px 50px rgba(91,95,239,.45); color: #fff; }

.btn-secondary {
  display: inline-flex; align-items: center; justify-content: center; gap: .6rem;
  padding: .9rem 2rem; border-radius: 99px; font-weight: 700; font-size: 1rem;
  text-decoration: none; font-family: 'Cairo', sans-serif; width: 100%;
  background: linear-gradient(135deg,#fff,#ffff); color: #5B5FEF;
  box-shadow: 0 12px 32px rgba(91,95,239,.3);
  transition: all .3s cubic-bezier(.4,0,.2,1);
}
.btn-secondary:hover { transform: translateY(-3px); box-shadow: 0 20px 50px rgba(91,95,239,.45); color: #5B5FEF; }
@keyframes floatY { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
</style>
